import {
  GET_NEWS_LIST_LOADING,
  GET_NEWS_LIST_SUCCESS,
  GET_NEWS_LIST_FAILURE,
} from "redux/types";

const initialState = {
  newsListLoading: false,
  newsList: null,
  errors: null,
};

export const newsListReducer = (state = initialState, aciton: any) => {
  switch (aciton.type) {
    case GET_NEWS_LIST_LOADING:
      return { ...state, newsListLoading: aciton.payload };
    case GET_NEWS_LIST_SUCCESS:
      return { ...state, newsList: aciton.payload };
    case GET_NEWS_LIST_FAILURE:
      return { ...state, errors: aciton.payload };
    default:
      return state;
  }
};
